module.exports = __webpack_public_path__ + "static/media/5.0689f1dd.jpg";